<template>
  <div class="ui-dp-wrap">
    <div
        ref="dp"
        class="ui-datepicker"
        v-bind:class="{
      opened: opened,
    }"
        :disabled="disabled"
        :valid="valid"
        :touched="touched"
        sklepalnik-ui-element
        @click="toggle"
    >
      <div class="ui-datepicker__backdrop" @click="toggle" ref="backdrop"></div>

      <div class="ui-datepicker__field" ref="field" @click="toggle">
        <input
            type="text"
            :name="name"
            class="datepicker__field-input icon-padding"
            :value="valueDateString"
            disabled
        />

        <datepicker
            class="datepicker"
            ref="datepicker"
            :wrapper-class="'datepicker__wrapper'"
            :input-class="'datepicker__input'"
            :calendar-class="'datepicker__cal'"
            @selected="onChange($event)"
            :value="value"
            :language="siLang"
            :inline="true"
            :monday-first="true"
            :disabled-dates="disabledDates"
            :open-date="openDate"
            v-hammer:swipe.horizontal="onCalendarSwipe"
        ></datepicker>

        <span class="label" v-bind:class="{ up: opened || value !== undefined }">
        {{ label }}
        <span v-if="required">*</span>
      </span>

        <div class="icon">
          <img src="./../../assets/icon-cal.svg" alt="cal">
        </div>
      </div>

      <field-validator
          v-if="showValidator()"
          ref="validator"
          :required="required"
          :validate="validate"
          :fieldname="name"
          :limit="true"
          :value="value"
          :type="Date"
          v-on:run-result="
        valid = $event;
        $emit('validated');
      "
      ></field-validator>
    </div>
  </div>
</template>

<script>
import Datepicker from "@hokify/vuejs-datepicker";
import {slSI} from "@hokify/vuejs-datepicker/dist/locale";
import Vue from "vue";
import FieldValidator from "./FieldValidator.vue";

import {
  FieldValidatorProps,
  FieldValidatorAcknowledgeFG,
} from "./FieldValidatorUtils";
import CommonMixin from "@/mixins/common.mixin";

export default {
  name: "ui-datepicker",
  components: {
    datepicker: Datepicker,
    "field-validator": FieldValidator,
  },
  mixins: [
    CommonMixin
  ],
  props: {
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Date,
      required: false,
    },
    // dokumentacija na https://www.npmjs.com/package/vuejs-datepicker
    disabledDates: {
      type: Object,
      required: false,
    },
    openDate: {
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    required: FieldValidatorProps.Required,
    validate: FieldValidatorProps.Validate,
  },
  data: function () {
    return {
      opened: false,
      siLang: slSI,
      valueDateString: undefined,
      valid: true,
      touched: false,
      fg: undefined,

      currentView: 'day',

      openedYear: undefined,
      openedMonth: undefined,
      monthsLabels: ['JAN', 'FEB', 'MAR', 'APR', 'MAJ', 'JUN', 'JUL', 'AVG', 'SEP', 'OKT', 'NOV', 'DEC']
    };
  },
  methods: {
    toggle($event) {
      $event.stopPropagation();
      if (this.disabled) return;

      if (this.opened) {
        this.close();
      } else {
        this.open();
      }
    },
    async open() {
      if (this.isMobile()) await this.forceCloseKeyboard();

      const dpBCR = this.$refs.dp.getBoundingClientRect();
      document.body.appendChild(this.$refs.dp);
      this.$refs.dp.style.position = 'fixed';
      this.$refs.dp.style.top = dpBCR.top + 'px';
      this.$refs.dp.style.width = dpBCR.width + 'px';
      this.$refs.dp.style.height = dpBCR.height + 'px';
      this.$refs.dp.style.left = dpBCR.left + 'px';
      this.$refs.dp.style.margin = '0';

      this.opened = true;
      this.intoDayView();

      const field = this.$refs.field;
      field.style.zIndex = 103;
      document.querySelector("body").style.overflow = "hidden";

      const screenHeight =
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight;

      const screenWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;

      let calendarHeight = 332;
      const fieldTop = field.getBoundingClientRect().top;
      let fieldTranslateString = "";

      if (this.isMobile() && (screenWidth < 1135) && (window.orientation ? window.orientation !== 90 : true)) {
        this.valueDateString = undefined;

        const calendarCenter =
            fieldTop + (field.clientHeight + calendarHeight) / 2;
        const screenCenter = screenHeight / 2;

        const centerDiff = Math.abs(calendarCenter - screenCenter);
        const translate = centerDiff * (screenCenter > calendarCenter ? 1 : -1);

        fieldTranslateString += `translateY(${translate}px)`;

        const currentCenter = field.getBoundingClientRect().x + field.getBoundingClientRect().width / 2;
        const moveXAxis = (screenWidth / 2) - currentCenter;

        fieldTranslateString += ` translateX(${moveXAxis}px)`;
        this.$refs.datepicker.$el.style.transform = 'translateY(10px)';
      } else {
        calendarHeight = 343;

        if (fieldTop + this.$refs.field.clientHeight + calendarHeight + 10 <= screenHeight - 5) {
          // position below field
          this.$refs.datepicker.$el.style.transform = 'translateY(10px)';
        } else if (fieldTop - 10 - calendarHeight >= 5) {
          // position above field
          const tranlateAboveField = (10 + this.$refs.field.clientHeight + 60) * -1;
          this.$refs.datepicker.$el.style.transform = `translateY(${tranlateAboveField - calendarHeight}px)`;
        } else {
          // center
        }

        this.$refs["datepicker"].$el.style.position = "fixed";
      }

      field.style.transform = fieldTranslateString;

      // move to year view
      this.$refs.dp.querySelector('.day__month_btn.up').click();
      this.$refs.dp.querySelector('.month__year_btn.up').click();

      setTimeout(() => {
        this.toggleBackdrop(true);
      }, 200);
    },
    close() {
      this.opened = false;

      const field = this.$refs.field;
      this.toggleBackdrop(false);

      // handle if element is padded - still show fullscreen centered, ignore padding
      if (this.$refs.field.clientWidth !== this.closedTargetWidth) {
        this.$refs.field.style.width = this.closedTargetWidth + "px";
      }

      field.style.transform = "";

      setTimeout(() => {
        document.querySelector("body").style.overflow = "auto";
        field.style.zIndex = 0;
        this.$refs["datepicker"].$el.style.position = "relative";
        this.setDateString(this.value);

        this.$el.appendChild(this.$refs.dp);
        this.$refs.dp.style.position = 'static';
        this.$refs.dp.style.top = 'unset';
        this.$refs.dp.style.width = '100%';
        this.$refs.dp.style.height = '46px';
        this.$refs.dp.style.left = 'unset';
      }, 300);
    },
    toggleBackdrop(value) {
      this.$refs.backdrop.style.transform = `scaleY(${Number(value)})`;
      this.$refs.backdrop.style.opacity = Number(value);
    },
    isMobile() {
      return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    },
    setupIcons() {
      // setup "next" icons
      const next = this.$refs.dp.querySelectorAll("span.next");
      for (let n_i = 0; n_i < next.length; n_i++) {
        next[n_i].innerHTML = `
      <svg class='datepicker-next' width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.5 10.5L0.5 5.5L5.5 0.5" stroke="#4C4C4C" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
      `;
        next[n_i].onclick = this.onNextClicked;
      }

      // setup "prev" icons
      const prev = this.$refs.dp.querySelectorAll("span.prev");
      for (let p_i = 0; p_i < prev.length; p_i++) {
        prev[p_i].innerHTML = `
      <svg class='datepicker-back' width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.5 10.5L0.5 5.5L5.5 0.5" stroke="#4C4C4C" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
        prev[p_i].onclick = this.onPrevClicked;
      }

      // stop every click from closing the datepicker
      const dp = this.$refs.dp.querySelector(".vdp-datepicker");
      dp.onclick = (e) => e.stopPropagation();
    },
    shortenMonths() {
      // set every month (in month view) to 3 characters
      const months = this.$refs.dp.querySelectorAll(
          ".vdp-datepicker__calendar .cell:not(.blank).month"
      );

      for (let m_i = 0; m_i < months.length; m_i++) {
        months[m_i].innerHTML = months[m_i].innerHTML.substring(0, 3);
      }
    },
    setDateString(value) {
      if (this.opened && this.isMobile()) {
        return;
      }

      if (value) {
        this.valueDateString = this.dateToString(this.value);
      } else {
        this.valueDateString = undefined;
      }
    },
    onChange(date) {
      this.$emit("change", date);
      this.$emit("fg-value-change");
      this.touched = true;
      this.close();
    },
    showValidator() {
      return (this.validate || this.required) && this.fg;
    },
    hasValidator() {
      return this.required || this.validate;
    },
    runValidator() {
      if (this.hasValidator()) {
        return this.$refs.validator.run();
      }
    },
    isValid() {
      return this.valid;
    },
    isTouched() {
      return this.touched;
    },
    intoMonthView(openedYear) {
      this.currentView = 'month';

      if (openedYear) {
        this.openedYear = openedYear;
      }

      this.shortenMonths();

      this.$refs.dp.querySelector('.month__year_btn.up').onclick = this.intoYearView;
      this.$refs.dp.querySelector('.month__year_btn.up').innerHTML = '&nbsp;&nbsp;&nbsp;' + this.openedYear + '&nbsp;&nbsp;      <svg class=\'datepicker-up\' width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M5.5 10.5L0.5 5.5L5.5 0.5" stroke="#4C4C4C" stroke-linecap="round" stroke-linejoin="round"/>\n</svg>';

      const monthsList = this.$refs.dp.querySelectorAll('.cell.month');
      for (let i = 0; i < monthsList.length; i++) {
        monthsList[i].onclick = this.intoDayView.bind(this, monthsList[i].innerText);
      }

      this.$refs.dp.querySelector('.month__year_btn.up').style.fontSize = '120%';
      this.$refs.dp.querySelector('.month__year_btn.up').style.fontWeight = 900;

      setTimeout(() => {
        this.$refs.dp.querySelector('.month__year_btn.up').style.fontSize = 'unset';
        this.$refs.dp.querySelector('.month__year_btn.up').style.fontWeight = 700;
      }, 200);
    },
    intoYearView() {
      this.currentView = 'year';

      this.openedYear = undefined;
      this.openedMonth = undefined;

      for (const y of this.$refs.dp.querySelectorAll("span.cell.year")) {
        y.onclick = this.intoMonthView.bind(this, +(y.innerText));
      }

      // have to do this manually cuz calendar library for some reason does not set a class to this
      let headerSpans = this.$refs.dp.querySelectorAll("header span");

      for (let hs_i = 1; hs_i < headerSpans.length; hs_i++) {
        if (
            headerSpans[hs_i].className === "" &&
            headerSpans[hs_i - 1].className === "prev"
        ) {
          headerSpans[hs_i].className = "years__range_btn up";
        }
      }

      this.$refs.dp.querySelector('.years__range_btn.up').style.fontSize = '110%';
      this.$refs.dp.querySelector('.years__range_btn.up').style.fontWeight = 900;

      setTimeout(() => {
        this.$refs.dp.querySelector('.years__range_btn.up').style.fontSize = 'unset';
        this.$refs.dp.querySelector('.years__range_btn.up').style.fontWeight = 700;
      }, 200);
    },
    intoDayView(openedMonth) {
      this.currentView = 'day';

      if (openedMonth) {
        this.openedMonth = openedMonth;
      }

      this.$refs.dp.querySelector('.day__month_btn.up').onclick = this.intoMonthView.bind(this, undefined);

      if (this.openedMonth) {
        const topLabel = this.openedMonth.charAt(0) + this.openedMonth.substring(1).toLowerCase() + ` ${this.openedYear}`;
        this.$refs.dp.querySelector('.day__month_btn.up').innerHTML = '&nbsp;&nbsp;&nbsp;' + topLabel + '&nbsp;&nbsp;      <svg class=\'datepicker-up\' width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M5.5 10.5L0.5 5.5L5.5 0.5" stroke="#4C4C4C" stroke-linecap="round" stroke-linejoin="round"/>\n</svg>';
      }

      this.$refs.dp.querySelector('.day__month_btn.up').style.fontSize = '120%';
      this.$refs.dp.querySelector('.day__month_btn.up').style.fontWeight = 900;

      setTimeout(() => {
        this.$refs.dp.querySelector('.day__month_btn.up').style.fontSize = 'unset';
        this.$refs.dp.querySelector('.day__month_btn.up').style.fontWeight = 700;
      }, 200);
    },
    onNextClicked() {
      if (this.currentView === 'day') {
        const currentMonthIndex = this.monthsLabels.indexOf(this.openedMonth);

        let nextMonthIndex = currentMonthIndex + 1;
        if (nextMonthIndex === this.monthsLabels.length) nextMonthIndex = 0;

        if (nextMonthIndex === 0) this.openedYear++;

        this.intoDayView(this.monthsLabels[nextMonthIndex]);
      } else if (this.currentView === 'month') {
        this.intoMonthView(this.openedYear + 1);
      } else if (this.currentView === 'year') {
        this.intoYearView();
      }

      this.$forceUpdate();
    },
    onPrevClicked() {
      if (this.currentView === 'day') {
        const currentMonthIndex = this.monthsLabels.indexOf(this.openedMonth);

        let prevMonthIndex = currentMonthIndex - 1;
        if (prevMonthIndex === -1) prevMonthIndex = 11;

        if (prevMonthIndex === 11) this.openedYear--;

        this.intoDayView(this.monthsLabels[prevMonthIndex]);
      } else if (this.currentView === 'month') {
        this.intoMonthView(this.openedYear - 1);
      } else if (this.currentView === 'year') {
        this.intoYearView();
      }

      this.$forceUpdate();
    },
    async forceCloseKeyboard() {
      return new Promise((resolve) => {
        const input = document.createElement('input');
        input.setAttribute('type', 'text');
        input.setAttribute('style', 'position: fixed; visibility: hidden;');

        document.body.appendChild(input);

        setTimeout(() => {
          input.focus();
          setTimeout(() => {
            input.setAttribute('style', 'display: none');
            resolve();
          }, 50)
        })
      }, 50)
    },
    onCalendarSwipe(event) {
      const order = ['day', 'month', 'year'];
      const i = order.indexOf(this.currentView);

      let buttons;

      if (event.direction === 2) {
        buttons = this.$refs.datepicker.$el.querySelectorAll('span.next');
      } else if (event.direction === 4) {
        buttons = this.$refs.datepicker.$el.querySelectorAll('span.prev');
      }

      if (buttons && buttons.length === 3) {
        buttons[i].click();
      }

      Vue.nextTick(() => {
        const currentViewString = this.currentView.charAt(0).toUpperCase() + this.currentView.substring(1);
        this[`into${currentViewString}View`]();
      });
    }
  },
  mounted: function () {
    this.setupIcons();
    FieldValidatorAcknowledgeFG.bind(this)();

    setTimeout(() => {
      FieldValidatorAcknowledgeFG.bind(this)();
    });

    if (this.required || this.validate) {
      this.valid = false;
    } else {
      this.valid = true;
    }

    this.setDateString(this.value);
    document.addEventListener("resize", this.setClosedTargetWidth);
  },
  destroyed: function () {
    document.removeEventListener("resize", this.setClosedTargetWidth);
    this.fg.onChildDestroyed(this);
  },
  watch: {
    value(newValue) {
      this.setDateString(newValue);

      Vue.nextTick(() => {
        this.runValidator();
      });
    },
    disabled() {
      this.close();
    },
    required() {
      Vue.nextTick(() => {
        this.fg.onElementValidateChanged(this);
      });
    },
    validate() {
      Vue.nextTick(() => {
        this.fg.onElementValidateChanged(this);
      });
    },
  },
};
</script>

<style>
.rtl {
  direction: rtl;
}

.vdp-datepicker {
  position: relative;
  text-align: left;
}

.vdp-datepicker * {
  box-sizing: border-box;
}

.vdp-datepicker__calendar {
  position: absolute;
  z-index: 100;
  background: #fff;
  width: 100%;

  height: 339px;
  max-width: 281px;
}

.vdp-datepicker__calendar > div {
  max-width: 255px;
  margin: 0 auto;
}

.vdp-datepicker__calendar header {
  display: block;
  height: 32px;
  margin: 8px 0;
}

.vdp-datepicker__calendar header span {
  display: inline-block;
  text-align: center;
  width: 71.42857142857143%;
  float: left;

  height: 100%;
}

.vdp-datepicker__calendar header span.day__month_btn,
.vdp-datepicker__calendar header span.month__year_btn,
.vdp-datepicker__calendar header span.years__range_btn {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 30px;

  text-align: center;
  color: #4c4c4c;

  cursor: pointer;

  transition: all 0.2s ease-in-out;
}

.vdp-datepicker__calendar header .next,
.vdp-datepicker__calendar header .prev {
  width: 14.285714285714286%;
  float: left;

  display: flex;
  justify-content: center;
  align-items: center;
}

.vdp-datepicker__calendar header .next .datepicker-next {
  transform: rotateZ(180deg);
}

.vdp-datepicker__calendar header .datepicker-up {
  transform: rotateZ(90deg);
  display: inline;
}

.vdp-datepicker__calendar header .next .datepicker-next,
.vdp-datepicker__calendar header .datepicker-up,
.vdp-datepicker__calendar header .prev .datepicker-back {
  height: 12px;
  width: 18px;
}

.vdp-datepicker__calendar header .next.disabled .datepicker-next path,
.vdp-datepicker__calendar header .disabled .datepicker-up path,
.vdp-datepicker__calendar header .prev.disabled .datepicker-back path {
  stroke: #ccc !important;
}

.vdp-datepicker__calendar .disabled {
  color: #ddd;
  cursor: default;
}

.vdp-datepicker__calendar .flex-rtl {
  display: flex;
  width: inherit;
  flex-wrap: wrap;
}

.vdp-datepicker__calendar .cell {
  display: inline-block;
  width: 32px !important;
  height: 32px !important;
  line-height: 32px !important;
  text-align: center !important;
  vertical-align: middle;

  border: 1px solid transparent;

  margin: 0 2px 8px 2px;

  font-family: "Open Sans";
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 32px;
  text-align: center;
}

.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year {
  cursor: pointer;

  font-family: "Open Sans";
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 32px;
  text-align: center;

  color: #4c4c4c;

  width: 32px;
  height: 32px;
}

.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover {
  border: 1px solid #4c4c4c;
  border-radius: 50%;
}

.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  border: 1px solid #4c4c4c;
  border-radius: 5px;
}

.vdp-datepicker__calendar .cell.selected {
  background: #4c4c4c;
  color: white !important;

  border-radius: 30px;
}

.vdp-datepicker__calendar .cell.selected:hover {
  background: #4c4c4c;
}

.vdp-datepicker__calendar .cell.selected.highlighted {
  background: #4c4c4c;
}

.vdp-datepicker__calendar .cell.highlighted {
  background: #cae5ed;
}

.vdp-datepicker__calendar .cell.highlighted.disabled {
  color: #a3a3a3;
}

.vdp-datepicker__calendar .cell.grey {
  color: #888;
}

.vdp-datepicker__calendar .cell.grey:hover {
  background: inherit;
}

.vdp-datepicker__calendar .cell.day-header {
  font-size: 75%;
  white-space: nowrap;
  cursor: inherit;

  font-family: "Open Sans";
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  text-align: center;

  color: #4c4c4c;
  margin-bottom: 20px;
}

.vdp-datepicker__calendar .cell.day-header:hover {
  background: inherit;
}

.vdp-datepicker__calendar .month,
.vdp-datepicker__calendar .year {
  width: 33.333%;
}

.vdp-datepicker__calendar-button,
.vdp-datepicker__clear-button {
  cursor: pointer;
  font-style: normal;
}

.vdp-datepicker__calendar-button.disabled,
.vdp-datepicker__clear-button.disabled {
  color: #999;
  cursor: default;
}

.vdp-datepicker__calendar .cell:not(.blank).month,
.vdp-datepicker__calendar .cell:not(.blank).year {
  display: inline-block;
  text-transform: uppercase;
  width: 30% !important;

  margin: 20px 4px;
}

.ui-dp-wrap {
  min-height: 46px;
}

@media (min-width: 280px) {
  .ui-dp-wrap {
    min-height: 46px;
    margin: 40px 0;
    max-width: 343px;
  }

  .ui-datepicker {
    width: 100%;
    max-width: 343px;
    height: 46px;
  }

  .ui-datepicker.opened {
    background-color: #f2f2f2;
    border-radius: 25px;
    z-index: 104;

    transition: all 0.6s ease-in-out, margin 0s;
  }

  .ui-datepicker .ui-datepicker__backdrop {
    position: fixed;
    top: 0;
    left: 0;

    height: 100vh;
    width: 100vw;

    background-color: rgba(0, 0, 0, 0.5);

    transform-origin: center;
    transform: scaleY(0);
    opacity: 0;
    transition: opacity 0.1s linear;
  }

  .ui-datepicker .ui-datepicker__field {
    position: relative;

    width: 100%;
    height: 100%;

    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }

  .ui-datepicker[touched]:not([valid])
  .ui-datepicker__field
  input.datepicker__field-input {
    border: 1px solid #ed1c24;
  }

  .ui-datepicker .ui-datepicker__field input.datepicker__field-input {
    width: 100%;
    height: 46px;
    background-color: #ffffff;
    color: black;
    opacity: 1;

    border: none;
    outline: none;

    padding: 10px 24px;
    border-radius: 25px;
    border: 1px solid #969696;

    transition: height 0.1s ease-in-out, border-radius 0.3s ease-in-out;
    pointer-events: none;
  }

  .ui-datepicker.opened .ui-datepicker__field input.datepicker__field-input {
    opacity: 1;
  }

  .ui-datepicker[disabled] .ui-datepicker__field input.datepicker__field-input {
    background-color: #e5e5e5;
    cursor: unset;
  }

  .ui-datepicker .ui-datepicker__field .datepicker__wrapper input {
    display: none;
  }

  .ui-datepicker .ui-datepicker__field .label {
    position: absolute;
    margin: 0;
    height: 25px;
    left: 24px;
    top: 9.5px;

    font-family: "Open Sans";
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 25px;
    color: #4c4c4c;

    transition: transform 0.1s ease-in-out, font-size 0.1s ease-in-out,
    background-color 0.2s ease, padding 0.2s ease;
  }

  div.ui-datepicker:not(.opened) .ui-datepicker__field .label.up {
    font-size: 12px !important;
    transform: translateY(-35px);
  }

  .ui-datepicker .ui-datepicker__field .icon-padding {
    padding-right: 46px !important;
  }

  .ui-datepicker .ui-datepicker__field .icon {
    display: inline-flex;
    justify-content: center;
    align-items: center;

    position: absolute;
    right: 3px;
    top: 3px;
    width: 40px;
    height: 40px;

    border: 3px solid transparent;
    border-radius: 24px;
    cursor: pointer;

    text-align: center;
    line-height: 34px;
    background-color: #4C4C4C;

    transition: transform 0.3s ease-in-out;
  }

  .ui-datepicker[disabled] .ui-datepicker__field .icon {
    cursor: unset;
  }

  .ui-datepicker:not([disabled]) .ui-datepicker__field .icon:hover,
  .ui-datepicker:not([disabled]).opened .ui-datepicker__field .icon {
    color: white !important;
    background: #4c4c4c !important;
  }

  .ui-datepicker .ui-datepicker__field .datepicker__wrapper {
    width: 100%;
    max-width: 281px;
    height: 0;
    overflow: hidden;
    margin: 0 auto;

    background-color: white;
  }

  .ui-datepicker.opened .ui-datepicker__field .datepicker__wrapper {
    height: 339px;
    border: 1.5px solid #ccc;

    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
  }
}

@media (min-width: 375px) {
  .ui-datepicker .ui-datepicker__field .datepicker__wrapper {
    max-width: 343px;
  }

  .ui-datepicker.opened .ui-datepicker__field .datepicker__wrapper {
    height: 389px;
  }

  .vdp-datepicker__calendar {
    max-width: 343px;
    height: 369px;
  }

  .vdp-datepicker__calendar > div,
  .vdp-datepicker__calendar {
    width: 343px;
    max-width: 343px;
  }

  .vdp-datepicker__calendar .cell {
    margin: 0 5.5px 8px 2px;
  }

  .vdp-datepicker__calendar .cell,
  .vdp-datepicker__calendar .cell.disabled {
    width: 40px !important;
    height: 40px !important;
    line-height: 36px !important;

    margin: 0 7px 5px 2px;
  }

  .vdp-datepicker__calendar .cell:not(.blank).day,
  .vdp-datepicker__calendar .cell:not(.blank).month,
  .vdp-datepicker__calendar .cell:not(.blank).year {
    font-size: 18px;
  }

  .vdp-datepicker__calendar .cell:not(.blank).month,
  .vdp-datepicker__calendar .cell:not(.blank).year {
    display: inline-block;
    margin: 20px 5px;
  }
}

@media (min-width: 1135px) {
  .ui-datepicker .ui-datepicker__backdrop {
    opacity: 0 !important;
  }

  .ui-datepicker .ui-datepicker__field .label.up {
    font-size: 12px !important;
    transform: translateY(-35px);
  }

}
</style>
